export default __webpack_public_path__ + "static/media/bike-thumbnail.333fb413.svg";